import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Services/Animations/aosLite.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/captions.css";
import { BrowserRouter } from 'react-router-dom';
import BJSpinner from './Components/Loader/BJSpinner';
import { I18nextProvider } from 'react-i18next';
import i18n from './Services/i18n/i18n';
import { bootstrapTenantUi } from './Services/bootstrap/tenantBoot';
import { bootstrapLanguage } from './Services/bootstrap/languageBoot';
import DirectionManager from './Components/DirectionManager/DirectionManager';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Ensure minimal tenant UI settings (favicon, title, colors) are applied before app render
(async () => {
  try {
    // Ensure language is chosen and applied before rendering anything
    await bootstrapLanguage();
    await bootstrapTenantUi();
  } finally {
    root.render(
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <DirectionManager />
          <App />
        </I18nextProvider>
      </BrowserRouter>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
